$mol_plot_group $mol_plot_graph
	sub <= graphs_enriched <= graphs /$mol_plot_graph
	Sample $mol_plot_graph_sample
		sub <= graph_samples /$mol_view
